import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import {Helmet} from "react-helmet";
import Navigation from './navigation';
import Footer from './footer';
import Hero from './assets/hero-2.svg';
import MobileHero from './assets/hero-mobile.svg';
import Business from './assets/undraw_business_deal.svg';
import Businessman from './assets/undraw_businessman.svg';
import Tourists from './assets/undraw_group_selfie.svg';
import Matt from './assets/matt-aidem.png';
import Aaron from './assets/aaron.png';
import Daniel from './assets/daniel.png';
import Dike from './assets/dike.png';
import Frances from './assets/frances.png';
import Raman from './assets/raman.png';
import Write from './assets/write.png';
import Scribbleplus from './assets/scribble-plus.svg';


class HomePage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }



  render() {
    console.log(this.state.width);

    return (
      <div>
        <Helmet>
        <title>Scribble – An on demand blog-writing subscription for startups 📝</title>
        <meta name="description" content="Scribble is an on demand blog-writing subscription for startups starting at $499/mo. Scribble is the easiest way to put your blog on autopilot. ✈️" />

        <meta itemprop="name" content="Scribble – An on demand blog-writing subscription for startups 📝" />
        <meta itemprop="description" content="Scribble is an on demand blog-writing subscription for startups starting at $499/mo. Scribble is the easiest way to put your blog on autopilot. ✈️" />
        <meta itemprop="image" content="http://i.imgur.com/dMNMVHO.png" />

        <meta property="og:url" content="https://www.hiscribble.com" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Scribble – An on demand blog-writing subscription for startups 📝" />
        <meta property="og:description" content="Scribble is an on demand blog-writing subscription for startups starting at $499/mo. Scribble is the easiest way to put your blog on autopilot. ✈️" />
        <meta property="og:image" content="http://i.imgur.com/dMNMVHO.png" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Scribble – An on demand blog-writing subscription for startups 📝" />
        <meta name="twitter:description" content="Scribble is an on demand blog-writing subscription for startups starting at $499/mo. Scribble is the easiest way to put your blog on autopilot. ✈️" />
        <meta name="twitter:image" content="http://i.imgur.com/dMNMVHO.png" />

        </Helmet>
        <Navigation />
        { this.state.width > 900 ? <img
          src={ Hero }
          className="is-overlay"
        /> : <img
          src={ MobileHero }
          className="is-overlay"
        />}

        <section className="section has-bg-image is-centered has-text-centered" style={{ height: "35em" }}>
          <div className="columns">
            <div className="column">
              <div className="container is-overlay has-padding-bottom has-text-centered">
                <div className="hero-div-width">
                  <h1 className="title has-text-white has-text-weight-bold is-hero-title is-size-2">
                    Scribble is an on demand blog-writing subscription for startups for just $499/mo 📝
                  </h1>
                   <br />
                </div>

                <AnchorLink href="#howitworks" className={ this.state.isActive ? 'button is-hiw-hero' : 'button is-hiw-hero'}>How it works</AnchorLink>
                <a className="button is-stripe-hero" href="/pricing">Subscribe now</a>
                <p className="has-text-white is-size-6 is-hero-sub">
                  Perfect for automating your blog & newsletters
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="container">
            <div className="columns has-text-centered is-centered">
              <div className="column is-hiw-card">
                <div className="circle-icon is-size-2 has-padding-bottom">
                  ✈️
                </div>
                <div className="title is-size-4 para-title">
                  Automate your blog so you can focus on your product & users
                </div>
              </div>
              <div className="column is-hiw-card">
                <div className="circle-icon is-size-2">
                  🤑
                </div>
                <div className="title is-size-4 para-title">
                  Improve your SEO, get more traffic, and attract new customers
                </div>
              </div>
              <div className="column is-hiw-card">
                <div className="circle-icon is-size-2">
                  ⚡️
                </div>
                <div className="title is-size-4 para-title">
                  Easily build your brand and reputation without the time commitment
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section has-opaque-bg has-background-white">
          <div className="container has-text-centered is-centered clear-section-card">
            <div className="pricing-head has-text-centered is-centered has-text-black">
              <h2 className="title has-text-centered is-centered" id="pricing">Why Scribble?</h2>
              <p className="subtitle has-text-centered is-centered pricing-sub">Blogs are one of the best ways to generate traffic for your product. But writing one yourself can take hundreds of hours a month. Scribble puts your blog on autopilot.</p>
            </div>
            <div className="columns">
              <div className="column">
                <div className="has-text-centered">
                  <div className="circle-icon is-size-2">
                    ✈️
                  </div>
                  <p className="has-text-weight-bold is-size-4">Grow your blog by putting it on autopilot<br /><br /></p>
                  <p className="is-size-6">

                  </p>
                </div>
              </div>
              <div className="column">
                <div className="has-text-centered">
                  <div className="circle-icon is-size-2">
                    📈
                  </div>
                  <p className="has-text-weight-bold is-size-4 person-title">Dramatically improve your SEO<br /><br /></p>
                  <p className="is-size-6">
                  </p>
                </div>
              </div>
            </div>
            <div className="columns">
              <div className="column">
                <div className="has-text-centered">
                <div className="circle-icon is-size-2">
                  🇺🇸
                </div>
                  <p className="has-text-weight-bold is-size-4 person-title">A team of writers who speak native English located in the USA<br /><br /></p>
                  <p className="is-size-6">
                  </p>
                </div>
              </div>
              <div className="column">
                <div className="has-text-centered">
                <div className="circle-icon is-size-2">
                  💌
                </div>
                  <p className="has-text-weight-bold is-size-4 person-title">Consistent content to share with your long-time users and new leads<br /><br /></p>
                  <p className="is-size-6">
                  </p>
                </div>
              </div>
            </div>
            <div className="columns">
              <div className="column">
                <div className="has-text-centered">
                <div className="circle-icon is-size-2">
                  🧐
                </div>
                  <p className="has-text-weight-bold is-size-4 person-title">Establish yourself as an expert and improve your brand’s reputation<br /><br /></p>
                  <p className="is-size-6">
                  </p>
                </div>
              </div>
              <div className="column">
                <div className="has-text-centered">
                <div className="circle-icon is-size-2">
                  ⚡️
                </div>
                  <p className="has-text-weight-bold is-size-4 person-title">Save yourself hundreds of hours every month by automating your blog-writing<br /><br /></p>
                  <p className="is-size-6">
                  </p>
                </div>
              </div>
            </div>
            <a className="button is-stripe-hero" href="/pricing">Subscribe now</a>
          </div>
        </section>

        <section className="section" id="howitworks">
          <div className="container clear-section-card-writing-samples">
            <div className="pricing-head has-text-centered is-centered has-text-black">
              <h2 className="title has-text-centered is-centered">How it works</h2>
              <p className="subtitle has-text-centered is-centered pricing-sub">Getting started with Scribble is simple and only takes a few minutes.</p>
            </div>
            <div className="columns">
              <div className="column is-hiw-card">
                <div className="circle-icon is-size-2">
                  💭
                </div>
                <div className="title is-size-4 para-title">
                  1. Send us a prompt or a loose idea of what you want written
                </div>

              </div>
              <div className="column is-hiw-card">
                <div className="circle-icon is-size-2">
                  🧠
                </div>
                <div className="title is-size-4 para-title">
                  2. We research & outline your blog post, then send you a rough draft
                </div>

              </div>
              <div className="column is-hiw-card">
                <div className="circle-icon is-size-2">
                  ✨
                </div>
                <div className="title is-size-4 para-title">
                  3. We work with you to refine this draft to perfection
                </div>

              </div>
              <div className="column is-hiw-card">
                <div className="circle-icon is-size-2">
                  📝
                </div>
                <div className="title is-size-4 para-title">
                  4. Export your post, then publish it to your blog
                </div>

              </div>
            </div>
            <p className="subtitle has-text-centered is-centered pricing-below-text is-size-6">Step 5: Repeat!</p>
          </div>
        </section>

          <section className="section">
            <div className="container has-text-centered is-centered">
              <h2 className="title section-title has-text-centered">Our Writers 📝</h2>
              <div className="columns">
                <div className="column">
                  <div className="has-text-centered">
                    <div>
                      <img
                      src= { Matt }
                      style= {{height:"5em"}}
                      />
                    </div>
                    <p className="has-text-weight-bold is-size-4 person-title">Matt Henderson</p>
                    <p className="is-size-6">
                    <b>Co-founder</b> • Growth hacker & designer featured by over 200 media outlets for projects like Rumblr and von Hughes<br /><br />
                    </p>
                  </div>
                </div>
                <div className="column">
                  <div className="has-text-centered">
                    <div>
                      <img
                      src= { Daniel }
                      style= {{height:"5em"}}
                      />
                    </div>
                    <p className="has-text-weight-bold is-size-4 person-title">Daniel Greenberg</p>
                    <p className="is-size-6">
                    <b>Co-founder</b> • Ex-Growth at Privacy.com, Director of Strategy at MSCHF, ran an Instagram account with 6M followers<br /><br />
                    </p>
                  </div>
                </div>
                <div className="column">
                  <div className="has-text-centered">
                    <div>
                      <img
                      src= { Aaron }
                      style= {{height:"5em"}}
                      />
                    </div>
                    <p className="has-text-weight-bold is-size-4 person-title">Aaron Tsai</p>
                    <p className="is-size-6">
                    <b>Co-founder & CTO</b> • Co-founder of Athena AI, Howler AI, and Cortlandt Labs, cancer research published by Science Signaling<br /><br />
                    </p>
                  </div>
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <div className="has-text-centered">
                    <div>
                      <img
                      src= { Raman }
                      style= {{height:"5em"}}
                      />
                    </div>
                    <p className="has-text-weight-bold is-size-4 person-title">Raman Mama</p>
                    <p className="is-size-6">
                    Contributing Writer at USA Today, ex-Content at Shanghaiist, ex-Marketing at Collective[i], Georgetown University<br /><br />
                    </p>
                  </div>
                </div>
                <div className="column">
                  <div className="has-text-centered">
                    <div>
                      <img
                      src= { Frances }
                      style= {{height:"5em"}}
                      />
                    </div>
                    <p className="has-text-weight-bold is-size-4 person-title">Frances Lee</p>
                    <p className="is-size-6">
                    Head of Campaigns at Howler AI, International Content Manager at Hearst, ex-International Editor at Giphy<br /><br />
                    </p>
                  </div>
                </div>
                <div className="column">
                  <div className="has-text-centered">
                    <div>
                      <img
                      src= { Dike }
                      style= {{height:"5em"}}
                      />
                    </div>
                    <p className="has-text-weight-bold is-size-4 person-title">Anthony Diké</p>
                    <p className="is-size-6">
                    Won creative writing awards at Columbia University, Computer Science at New York University<br /><br />
                    </p>
                  </div>
                </div>
              </div>
              <a className="button is-stripe-hero" href="/pricing" style={{marginTop:'2em'}}>Subscribe now</a>
              </div>
            </section>

            <section className="section">
              <div className="container clear-section-card-writing-samples has-text-centered">
                <div className="pricing-head has-text-centered is-centered has-text-black">
                  <h2 className="title has-text-centered is-centered">Writing Samples</h2>
                  <p className="subtitle has-text-centered is-centered pricing-sub">We've written for many different kinds of publications – from sports and music to business and technology.</p>
                </div>
                <div className="columns has-text-centered">
                  <div className="column is-hiw-card is-sample-card">
                    <a target="_blank" href="https://www.westvesey.com/why-were-building-24-businesses-in-12-months/?ref=scribble">
                    <div className="title is-size-4 para-title">
                      Why we're building 24 businesses in 12 months
                    </div>
                    <p className="is-small-header">PUBLISHED BY WEST VESEY</p>
                    </a>
                  </div>
                  <div className="column is-hiw-card is-sample-card">
                    <a target="_blank" href="https://theascent.pub/childish-gambino-how-to-spend-10-years-the-road-to-creative-mastery-c67e2213ad25">
                    <div className="title is-size-4 para-title">
                      Childish Gambino: How to spend 10 years — The Road to Creative Mastery
                    </div>
                    <p className="is-small-header">PUBLISHED BY THE ASCENT</p>
                    </a>
                  </div>
                  <div className="column is-hiw-card is-sample-card">
                    <a target="_blank" href="https://medium.com/the-mission/how-we-hacked-the-media-and-landed-six-figure-contracts-in-four-days-96ea4aca4eef">
                    <div className="title is-size-4 para-title">
                      How We Hacked the Media and Landed Six-Figure Contracts in Four Days
                    </div>
                    <p className="is-small-header">PUBLISHED BY THE MISSION</p>
                    </a>
                  </div>
                  <div className="column is-hiw-card is-sample-card">
                    <a target="_blank" href="https://medium.com/the-mission/3-entrepreneurs-who-lost-before-they-won-face28cbcca0">
                    <div className="title is-size-4 para-title">
                      3 Entrepreneurs Who Lost Before They Won
                    </div>
                    <p className="is-small-header">PUBLISHED BY THE MISSION</p>
                    </a>
                  </div>
                </div>
              </div>
            </section>


                    <section className="section">
                      <div className="container clear-section-card">
                        <div className="pricing-head has-text-centered is-centered has-text-black">
                          <h2 className="title has-text-centered is-centered">Writing and promoting your blog put on autopilot ✈️</h2>
                          <p className="subtitle has-text-centered is-centered pricing-sub">Scribble and Exclamation together is the easiest way to write and grow your blog.</p>
                        </div>
                          <a href="/exclamation?ref=scribbleplus">
                            <img
                              src={ Scribbleplus }
                            />
                          </a>
                      </div>
                    </section>

                    <section className="section" id="FAQ">
                      <div className="container clear-section-card-writing-samples">
                        <div className="pricing-head has-text-centered is-centered has-text-black">
                          <h2 className="title has-text-centered is-centered">FAQ</h2>
                          <p className="subtitle has-text-centered is-centered pricing-sub">If our FAQ doesn't answer your questions, please reach out to us in our live chat in the bottom right.</p>
                        </div>
                        <div className="columns">
                          <div className="column is-hiw-card">
                            <div className="title is-size-5">
                              How long does it take to process a writing request for Scribble?
                            </div>
                            <p className="is-size-6">After submitting a request, we’ll spend 3-5 business days researching and outlining your post, then send you a rough draft. We’ll work with you for as long as you like to refine that post until it’s ready for you to publish.</p>
                          </div>
                          <div className="column is-hiw-card">
                            <div className="title is-size-5">
                              For Scribble, do you offer refunds?
                            </div>
                            <p className="is-size-6">You can cancel your subscription anytime. We have a 100% money-back guarantee until we’ve started processing a writing request that month.</p>
                          </div>
                        </div>
                        <div className="columns">
                          <div className="column is-hiw-card">
                            <div className="title is-size-5">
                              What is a writing request?
                            </div>
                            <p className="is-size-6">A writing request is one prompt submission––you'll get a special form after you sign up that walks you through everything.</p>
                          </div>
                          <div className="column is-hiw-card">
                            <div className="title is-size-5">
                              For Scribble, can you add photos to the posts?
                            </div>
                            <p className="is-size-6">Yes.</p>
                          </div>
                        </div>
                        <div className="columns">
                          <div className="column is-hiw-card">
                            <div className="title is-size-5">
                              Do you have any writing samples?
                            </div>
                            <p className="is-size-6">Yes, see above.</p>
                          </div>
                          <div className="column is-hiw-card">
                            <div className="title is-size-5">
                              For Scribble, do you write in any language other than English?
                            </div>
                            <p className="is-size-6">Not yet.</p>
                          </div>
                        </div>
                      </div>
                    </section>

        <Footer />
      </div>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/homepage.js